// Redux
import { Dispatch } from "redux";

// Classes
import { EthnicityReducerState } from "../classes/ethnicity.classes";

// Action Creators
import {
  setAmericanIndianOrAlaskaNative,
  setAsian,
  setBlackOrAfricanAmerican,
  setNativeHawaiianOrOtherPacificIslander,
  setHispanicOrLatin,
  setWhite,
  setMixedRace,
  setOther,
  setEthnicityState
} from "../actionCreators/ethnicity.actionCreators";

export const setEthnicityValue = (
  dispatch: Dispatch<any>,
  value: boolean,
  identifier:
    | "americanIndianOrAlaskaNative"
    | "asian"
    | "blackOrAfricanAmerican"
    | "hispanicOrLatin"
    | "nativeHawaiianOrOtherPacificIslander"
    | "white"
    | "mixedRace"
    | "other"
    | "blank"
) => {
  switch (identifier) {
    case "americanIndianOrAlaskaNative":
      dispatch(setAmericanIndianOrAlaskaNative(!value));
      break;
    case "asian":
      dispatch(setAsian(!value));
      break;
    case "blackOrAfricanAmerican":
      dispatch(setBlackOrAfricanAmerican(!value));
      break;
    case "hispanicOrLatin":
      dispatch(setHispanicOrLatin(!value));
      break;
    case "nativeHawaiianOrOtherPacificIslander":
      dispatch(setNativeHawaiianOrOtherPacificIslander(!value));
      break;
    case "white":
      dispatch(setWhite(!value));
      break;
    case "mixedRace":
      dispatch(setMixedRace(!value));
      break;
    case "other":
      dispatch(setOther(!value));
      break;
  }
};

export const initializeEthnicityState = (
  dispatch: Dispatch<any>,
  state: EthnicityReducerState
) => {
  dispatch(setEthnicityState(state));
};
